
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[invoice]",
      function () {
        return require("private-next-pages/[invoice]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[invoice]"])
      });
    }
  